// src/utils/usernameGenerator.js
const adjectives = [
  "invincible",
  "Golden",
  "Electric",
  "Hidden",
  "Cosmic",
  "Crimson",
  "Lucky",
  "Brave",
  "Shadow",
  "Crystal",
  "Iron",
  "Rapid",
  "Neon",
  "Curious",
  "Calm",
  "Swift",
  "Bright",
  "Silver",
  "Ancient",
  "Wild",
  "Clever",
  "Quiet",
  "Bold",
  "Fierce",
  "Noble",
  "Radiant",
  "Steady",
  "Stormy",
  "Frozen",
  "Burning",
  "Flying",
  "Wandering",
  "Lone",
  "Wise",
  "Gentle",
  "Mighty",
  "Daring",
  "Shining",
  "Restless",
  "Fearless",
  "Glowing",
  "Sharp",
  "Deep",
  "Amber",
  "Emerald",
  "Azure",
  "Scarlet",
  "Obsidian",
  "Ivory",
  "Thunder"
];

const nouns = [
  "Falcon",
  "Voyager",
  "Tiger",
  "Wolf",
  "Phoenix",
  "Comet",
  "Scholar",
  "Navigator",
  "Lion",
  "Hawk",
  "Panther",
  "Nomad",
  "Builder",
  "Oracle",
  "Pilot",
  "Ranger",
  "Guardian",
  "Seeker",
  "Hunter",
  "Keeper",
  "Sailor",
  "Climber",
  "Drifter",
  "Thinker",
  "Runner",
  "Watcher",
  "Speaker",
  "Writer",
  "Dreamer",
  "Rider",
  "Captain",
  "Sentinel",
  "Explorer",
  "Strategist",
  "Architect",
  "Engineer",
  "Inventor",
  "Messenger",
  "Diplomat",
  "Pioneer",
  "Pathfinder",
  "Harbinger",
  "Beacon",
  "Lantern",
  "Compass",
  "Anchor",
  "Summit",
  "Horizon",
  "Atlas",
  "Voyage",
  "Magician",
  "Wizard",
  "Ruler",
  "Priest",
  "Chief",
  "Pharaoh",
  "Lion",
  "Energy"
];

const spiritualNumbers = [
  111, 222, 333, 444, 555, 666, 777, 888, 999,
  1010, 1111, 1212, 1313, 1414,
  7777, 8888, 9999, 101, 1, 0,
];

export function generateUsername() {
  const adj = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  const number = spiritualNumbers[Math.floor(Math.random() * spiritualNumbers.length)];

  return `${adj}${noun}${number}`;
}